const data = {
  id: "housing_crisis",
  title: "Housing Crisis",
  intro: "Why does every new development in Huntsville seem to be luxury? Where did the affordable housing go — and why are encampments being criminalized instead of addressed? The decisions turning a housing shortage into a permanent housing crisis — documented.",
  tabs: [
    {
      id: "overview",
      label: "Overview",
      visual: { type: "placeholder", title: "In-progress visual", description: "This section is being expanded now. The shell is in place so the page loads cleanly while content is rebuilt." },
      issues: [],
      trail: []
    },
    {
      id: "affordability",
      label: "Affordability",
      stats: [],
      issues: [],
      trail: []
    },
    {
      id: "displacement_demolition",
      label: "Displacement & Demolition",
      stats: [],
      issues: [],
      trail: []
    },
    {
      id: "encampments",
      label: "Encampments & Criminalization",
      stats: [],
      issues: [],
      trail: []
    },
    {
      id: "luxury_investor",
      label: "Luxury & Investor Market",
      stats: [],
      issues: [],
      trail: []
    }
  ]
};
export default data;
